export function getAtwDirectoryReleaseVersion(): string {
  return import.meta.env.VITE_DIRECTORY_RELEASE || "V26.1.011";
}

export function formatAtwReleaseLabel(version: string): string {
  return version.startsWith("V") ? version : `V${version}`;
}
